import styled from 'styled-components';

export const WebpageContainer = styled.div`
  margin-top: 4px;
  margin-bottom: 24px;
`;

export const WebpageLabel = styled.p`
  font-weight: bold;
  margin: 0 0 4px 0;
`;

export const WebpageLinkRow = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;

  .anticon {
    cursor: pointer;
    font-size: 16px;
    color: #1890ff;
  }
`;

export const WebpageLink = styled.a`
  color: inherit;
  text-decoration: none;
  font-weight: 600;

  &:hover {
    text-decoration: underline;
  }
`;
